import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ProfileStateProvider {
  public isProfileOpen = signal(false);
}
